module.exports = __webpack_public_path__ + "static/72-e67f8c6251dffce75183d25b97e6fcea.png";